import { render, staticRenderFns } from "./FollowupsQueue.vue?vue&type=template&id=262d9a6e&scoped=true"
import script from "./FollowupsQueue.vue?vue&type=script&lang=js"
export * from "./FollowupsQueue.vue?vue&type=script&lang=js"
import style0 from "./FollowupsQueue.vue?vue&type=style&index=0&id=262d9a6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "262d9a6e",
  null
  
)

export default component.exports